import React, { useEffect } from "react";
import styles from "../OpenAnAccount/openAnAccount.module.css";
import Mail from "../../commomComponents/mail";
import formName from "../../assets/images/form-name.svg";
import formOtp from "../../assets/images/form-otp.svg";
import formMail from "../../assets/images/form-mail.svg";
import formContact from "../../assets/images/form-contact.svg";
import query from "../../assets/images/select-inquiry-golden.svg";
import originalQuery from "../../assets/images/select-inquiry-gray.svg";
import formNameChange from "../../assets/images/form-name-golden.svg";
import formMailChange from "../../assets/images/form-mail-golden.svg";
import formContactChange from "../../assets/images/form-contact-golden.svg";
import formOtpChange from "../../assets/images/form-otp-golden.svg";
import getOpenAccountDetails from "../../services/request/openAccount";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import ReactHtmlParser from "react-html-parser";

import { validateOTP, sendEnteredOTP } from "../../services/request/otp";
import { useState } from "react";
import { getEmailTemplate } from "../../utils/getEmailTemplate";

import setCreateAccountDetails from "../../services/setRequest/setCreateAccountDetails";

import {
  InputLabel,
  TextField,
  MenuItem,
  FormControl,
  Select,
} from "@material-ui/core";

import { sender } from "../../utils/sendMail";
import Timer from "../../commomComponents/OtpTimer";

import {
  encrypt,
  decrypt,
  generateSecreteKey,
  createRequestIds,
} from "../../services/encryptionDecryptionService";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import { EMAIL_PLACEHOLDER, encryptDecryptKey } from "../../constants/Constants";

const OpenAnAccount = () => {
  const [inquiry, setInquiry] = React.useState("");
  const [changeImage, setChangeImage] = React.useState(false);
  const [fullname, setFullName] = React.useState("");
  const [nameErrorMsg, setNameErrorMsg] = React.useState(false);
  const [errorMsg, setErrorMsg] = React.useState(false);
  const [changeMail, setChanEemail] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [emailErrorMsg, setEmailErrorMsg] = React.useState(false);
  const [changeContact, setChangeContact] = React.useState(false);
  const [isActive, setIsActive] = useState(false);
  const [countryCode, setCountryCode] = React.useState(false);
  const [contactNumber, setContactNumber] = React.useState("");
  const [numberErrorMsg, setNumberErrorMsg] = React.useState(false);
  const [otp1, setOtp1] = React.useState("");
  const [otp2, setOtp2] = React.useState("");
  const [otp3, setOtp3] = React.useState("");
  const [otp4, setOtp4] = React.useState("");
  const [otp, setOtp] = React.useState("");
  const [changeOtp, setChangeOtp] = React.useState(false);
  const [dataLabel, setDataLabel] = React.useState(false);
  const [otpClass, setOtpClass] = React.useState(false);
  const [otpErrorMsg, setOtpErrorMsg] = React.useState(false);
  const [responseData, setResponseData] = React.useState([]);
  const [disclaimer, setDisclaimer] = React.useState([]);
  const [banner, setbanner] = React.useState([]);

  const [otpData, setOtpData] = React.useState({});
  const [otpSent, setOtpSent] = React.useState(false);
  const [otpBtnText, setOtpBtnText] = React.useState("Send OTP");

  const [otpVerified, setOtpVerified] = React.useState(true);
  const [mobVerified, setMobVerified] = React.useState(false);

  const [requestId, setRequestId] = React.useState(0);
  const [requestIDs, setRequestIds] = React.useState([]);

  const handleChange = (event) => {
    setInquiry(event.target.value);
  };

  // const validateEnteredOTP = (num) => {
  //   if (num.length == 4) {
  //     setOtp(num);
  //     validateOTP(contactNumber, num);
  //     setOtpErrorMsg(false);
  //   }
  //   else {
  //     setOtpErrorMsg(true);
  //   }
  // };

  function setOtpSentToFalse() {
    setOtpSent(false);
    setOtpBtnText("Resend OTP");
  }

  async function sendOTP() {
    if (!contactNumber) {
      return;
    }
    const regexExp = /^[6-9]\d{9}$/gi;

    if (!regexExp.test(contactNumber)) {
      return;
    }
    setDataLabel(true);
    let secret = generateSecreteKey(5);
    let reqId = createRequestIds(requestId, secret);
    let reqIds = requestIDs;
    reqIds.push(reqId);
    setRequestIds(reqIds);
    console.log("reqId:" + reqId.requestId);
    let payload = {
      mobileNo: contactNumber,
      //"otp":otp,
      // txnId: reqId.requestId,
    };

    let encrypted = encrypt(payload, secret);

    let response = await sendEnteredOTP(JSON.stringify(encrypted));
    console.log('sendEnteredOTP Response 1: ', response);
    var ENCRYPTED_KEY = changeRequestId(response.data.part2);
    // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
    let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
    console.log("DEcrypted dta", decryptedData);
    setOtpData(decryptedData);
    setOtpSent(true);
  }

  function setOtpSentToFalse() {
    setOtpSent(false);
    setOtpBtnText("Resend OTP");
  }

  const handleOTPfocus = async (e) => {
    //document.querySelector('input[id="otp2"]').focus()
    if (e.target.dataset["prev"] == "otp3") {
      let _otp =
        "" +
        window.document.getElementById("otp1").value +
        window.document.getElementById("otp2").value +
        window.document.getElementById("otp3").value +
        window.document.getElementById("otp4").value;
      await validateEnteredOTP(_otp);
    }
    if (
      (e.key === "Delete" || e.key === "Backspace") &&
      e.target.dataset["prev"]
    ) {
      document
        .querySelector('input[id="' + e.target.dataset["prev"] + '"]')
        .focus();
    } else if (e.target.dataset["next"]) {
      document
        .querySelector('input[id="' + e.target.dataset["next"] + '"]')
        .focus();
    }
  };

  function handleImageChangeFormName() {
    setChangeImage(true);
  }
  function handleChangeImageFormName() {
    setChangeImage(false);
  }
  function handleImageChangeFormMail() {
    setChanEemail(true);
  }
  function handleChangeImageFormMail() {
    setChanEemail(false);
  }
  function handleImageChangeFormContact() {
    setChangeContact(true);
  }
  function handleChangeImageFormContact() {
    setChangeContact(false);
  }
  function handleImageChangeFormOtp() {
    setChangeOtp(true);
  }
  function handleChangeImageFormOtp() {
    setChangeOtp(false);
  }

  const validateEnteredOTP = async (num) => {
    alert("Please wait, verifying OTP...");
    if (num.length === 4) {
      setOtp(num);
      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);
      console.log("reqId:" + reqId.requestId);
      let payload = {
        mobileNo: contactNumber,
        otp: parseInt(num),
        // txnId: reqId.requestId,
      };
      console.error(payload);
      let encrypted = encrypt(payload, secret);

      let response = await validateOTP(JSON.stringify(encrypted));
      console.log('validateOTP Response: ', response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("DEcrypted data", decryptedData);

      if (decryptedData.status == "success") {
        alert("OTP verified!");
        setOtpVerified(true);
        setMobVerified(true);
      } else {
        alert("Something went wrong");
        setOtpVerified(false);
        setMobVerified(false);
      }
    } else {
      setOtpErrorMsg(true);
    }
  };

  function handleChangeName(event) {
    let alphabets =
      /^[\u00C0-\u017Fa-zA-Z'’‘’][\u00C0-\u017Fa-zA-Z’‘’' ' ']+[\u00C0-\u017Fa-zA-Z'’‘’]?$/;
    let name = event.target.value;
    setFullName(name);
    if (name.match(alphabets)) {
      setNameErrorMsg(false);
    } else if (name.match(/^[A-Z]*$/)) {
      setNameErrorMsg(false);
    } else {
      setNameErrorMsg(true);
    }
  }
  function handleEmailChange(event) {
    let email = event.target.value;
    setEmail(email);
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
      setEmailErrorMsg(false);
    } else {
      setEmailErrorMsg(true);
    }
  }
  function handleTextChange(text) {
    let num = /^-?\d*$/.test(text);
    if (num) {
      setIsActive(true);
      setCountryCode(true);
      setContactNumber(text);
      setNumberErrorMsg(false);
    } else {
      setNumberErrorMsg(true);
    }
  }

  function handleChangeOtp1(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp1(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp2(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp2(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp3(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp3(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }
  function handleChangeOtp4(event) {
    let num = /^-?\d*$/.test(event.target.value);
    if (num) {
      setOtp4(event.target.value);
      setOtpErrorMsg(false);
      setDataLabel(true);
    } else {
      setDataLabel(false);
    }
  }

  function handleInput() {
    // setDataLabel(!dataLabel);
    setOtpClass(true);
  }

  async function handleSubmit() {
    if (fullname === "") {
      setErrorMsg(true);
    } else {
      setErrorMsg(false);
    }
    if (email === "") {
      setEmailErrorMsg(true);
    } else if (email !== "") {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        setEmailErrorMsg(false);
      } else {
        setEmailErrorMsg(true);
      }
    }
    if (contactNumber === "") {
      setNumberErrorMsg(true);
    } else {
      setNumberErrorMsg(false);
    }
    if (otp1 === "" || otp2 === "" || otp3 === "" || otp4 === "") {
      setOtpErrorMsg(true);
    } else {
      setOtpErrorMsg(false);
    }
    if (!fullname || !email || !contactNumber || !mobVerified) {
      return;
    } else {
      // let emailTemplate = getEmailTemplate("enquiry");
      // let subject = "New Booking Details for ICICI Prudential PMS";
      // emailTemplate = emailTemplate.replace("{{subject}}", "New Booking Details for ICICI Prudential PMS")
      //     .replace("{{name}}", fullname)
      //     .replace("{{emailId}}", email)
      //     .replace("{{contactNumber}}", contactNumber)
      //     console.log(emailTemplate,'emajhsjk')
      // sender(emailTemplate, email, subject);

      let secret = generateSecreteKey(5);
      let reqId = createRequestIds(requestId, secret);
      let reqIds = requestIDs;
      reqIds.push(reqId);
      setRequestIds(reqIds);
      console.log("reqId:" + reqId.requestId);
      let payload = {
        fullName: fullname,
        email: email,
        contactNo: contactNumber,
        // txnId: reqId.requestId,
      };

      let encrypted = encrypt(payload, secret);
      console.log("encrypted dta", encrypted);

      let response = await setCreateAccountDetails(JSON.stringify(encrypted));
      console.log('setCreateAccountDetails Response: ', response);
      var ENCRYPTED_KEY = changeRequestId(response.data.part2);
      // let decryptedData = decrypt(response.data.part1, ENCRYPTED_KEY);
      let decryptedData = decrypt(response.data.part1, encryptDecryptKey);
      console.log("DEcrypted dta", decryptedData);
      if (decryptedData.status == "success") {
        alert("Successfully sent");
        window.location.reload();
      } else {
        alert("Something went wrong");
      }
    }
  }

  let data;
  let disclaimerText;
  let bannerImage;
  useEffect(() => {
    document.title = "Invest Now";
    async function callApis() {
      await getAccountDeails();
    }
    callApis();
  }, []);

  async function getAccountDeails() {
    const home = getOpenAccountDetails();
    home.then((response) => {
      bannerImage = response.data.banner[0];
      data = response.data.form[0];
      disclaimerText = response.data.disclaimer;
      setResponseData(data);
      setDisclaimer(disclaimerText);
      setbanner(bannerImage);
    });
  }

  function changeRequestId(txnId) {
    var secret = "";
    console.warn(JSON.stringify(requestIDs));
    var latest = requestIDs.filter(function (val) {
      console.log("val", val);
      if (val.requestId === txnId) {
        secret = val.secret.substring(
          0,
          val.secret.length - val.requestId.length
        );
        return false;
      }
      return true;
    });
    setRequestIds(latest);
    return secret;
  }

  return (
    <div className={styles.contactUs}>
      <Mail />
      <BannerWithHeading
        bannerImage={IMAGE_URL + banner.image + SITE_ID}
        heading={banner.title}
        headingColor="#97291e"
      />
      <div className={styles.openAccountContainer}>
        <div className={styles.contactBanner}>
          {/* <img src={investBanner} alt="investBanner" /> */}
          <img
            src={IMAGE_URL + responseData["image"] + SITE_ID}
            alt="investBanner"
          />
          <div className={styles.investText}>
            <p className={styles.welcomeText}>{responseData["title"]}</p>
            <div className={styles.welcomeContent}>
              {responseData["description"]}
            </div>
          </div>
        </div>
        <div className={styles.formContainer}>
          <h5 className={styles.contactUsHeading}>Create Account</h5>
          <p className={styles.createContent}>
            Get started by creating an account with us in 2 simple steps
          </p>

          <FormControl
            variant="standard"
            sx={{ m: 1, minWidth: 120 }}
            className={styles.investForm}
          >
            <div className={`mailInputWrapper ${styles.inputwrapper}`}>
              <div
                onMouseOver={handleImageChangeFormName}
                onMouseLeave={handleChangeImageFormName}
              >
                {changeImage ? (
                  <img src={formNameChange} alt="form-name-golden" />
                ) : (
                  <img src={formName} alt="form-name" />
                )}
              </div>
              <div
                className={`textFieldContainer ${styles.contactfullnameField}`}
              >
                <TextField
                  id="full-name"
                  label="Full Name"
                  type="name"
                  autoComplete=""
                  InputProps={{ disableUnderline: true }}
                  className={styles.contactTextfield}
                  placeholder="Arjun Kumar"
                  onChange={(e) => handleChangeName(e)}
                  value={fullname}
                  required
                  inputProps={{ maxLength: 64 }}
                />
              </div>
            </div>
            {nameErrorMsg ? (
              <span className={styles.errorMsgContact}>Enter valid Name</span>
            ) : (
              ""
            )}
            {errorMsg ? (
              <span className={styles.errorMsgContact}>Required</span>
            ) : (
              ""
            )}
            <div className={`mailInputWrapper ${styles.inputwrapper}`}>
              <div
                onMouseOver={handleImageChangeFormMail}
                onMouseLeave={handleChangeImageFormMail}
              >
                {changeMail ? (
                  <img src={formMailChange} alt="form-mail-golden" />
                ) : (
                  <img src={formMail} alt="form-mail" />
                )}
              </div>
              <div
                className={`textFieldContainer ${styles.contactfullnameField}`}
              >
                <TextField
                  id="email"
                  label="Email"
                  type="email"
                  autoComplete=""
                  InputProps={{ disableUnderline: true }}
                  className={styles.contactTextfield}
                  placeholder={EMAIL_PLACEHOLDER}
                  required
                  value={email}
                  onChange={(e) => handleEmailChange(e)}
                  inputProps={{ maxLength: 70 }}
                />
              </div>
            </div>
            {emailErrorMsg ? (
              <span className={styles.errorMsgContact}>Enter valid email</span>
            ) : (
              ""
            )}
            {errorMsg ? (
              <span className={styles.errorMsgContact}>Required</span>
            ) : (
              ""
            )}
            <div className={`mailInputWrapper ${styles.inputwrapper}`}>
              <div
                onMouseOver={handleImageChangeFormContact}
                onMouseLeave={handleChangeImageFormContact}
              >
                {changeContact ? (
                  <img src={formContactChange} alt="form-contact-golden" />
                ) : (
                  <img src={formContact} alt="form-contact" />
                )}
              </div>
              <div className="contactInput">
                <label className={`${isActive ? "Active" : "contactLabel"} `}>
                  Contact Number<span className="asterick">*</span>
                </label>
                <div className="contactNumbercode">
                  {countryCode ? <span className="countryCode">+91-</span> : ""}{" "}
                  <input
                    type="text"
                    className="contactNumber"
                    onChange={(e) => handleTextChange(e.target.value)}
                    onClick={() => setCountryCode(true)}
                    onBlur={() => {
                      if (!contactNumber) {
                        setCountryCode(false);
                      }
                    }}
                    value={contactNumber}
                    maxLength={10}
                  // placeholder="9880546703"
                  />
                </div>
              </div>
            </div>
            {numberErrorMsg ? (
              <span className={styles.errorMsgContact}>
                Enter valid Contact Number
              </span>
            ) : (
              ""
            )}
            {errorMsg ? (
              <span className={styles.errorMsgContact}>Required</span>
            ) : (
              ""
            )}
            <div className={styles.sendResentContainer}>
              {!otpSent ? (
                <a
                  onClick={() => {
                    sendOTP();
                  }}
                  className={styles.otpwrapperSendAccount}
                >
                  {otpBtnText}
                </a>
              ) : (
                <Timer data={otpData} setOtpSent={setOtpSentToFalse} />
              )}
              {/* <div className={styles.otpwrapperSendAccount}>Send OTP</div>
              <div className={styles.otpwrapper}>Resend OTP</div> */}
            </div>
            <div>
              <div className={`mailOtpInput ${styles.otpinputWrapper}`}>
                <div className={styles.inputwrapper1}>
                  <div
                    onMouseOver={handleImageChangeFormOtp}
                    onMouseLeave={handleChangeImageFormOtp}
                  >
                    {changeOtp ? (
                      <img src={formOtpChange} alt="form-otp-golden" />
                    ) : (
                      <img src={formOtp} alt="form-otp" />
                    )}
                  </div>
                  <div className="otpInputfieldOpenAccount">
                    <label
                      className={`${dataLabel ? "Active" : "accountlabel"} `}
                    >
                      Provide OTP
                    </label>

                    <div
                      className={`${otpClass ? "giveBorder" : "otpContainerAccount"
                        } `}
                    >
                      <input
                        name="otp1"
                        type="text"
                        id="otp1"
                        data-next="otp2"
                        data-prev="otp1"
                        autoComplete="off"
                        className="otpInput"
                        value={otp1}
                        onChange={(e) => handleChangeOtp1(e)}
                        tabIndex="1"
                        maxLength="1"
                        onFocus={handleInput}
                        onKeyUp={(e) => handleOTPfocus(e)}
                      />
                      <input
                        name="otp2"
                        type="text"
                        id="otp2"
                        data-next="otp3"
                        data-prev="otp1"
                        autoComplete="off"
                        className="otpInput"
                        value={otp2}
                        onChange={(e) => handleChangeOtp2(e)}
                        tabIndex="2"
                        maxLength="1"
                        onFocus={handleInput}
                        onKeyUp={(e) => handleOTPfocus(e)}
                      />
                      <input
                        name="otp3"
                        type="text"
                        id="otp3"
                        data-next="otp4"
                        data-prev="otp2"
                        autoComplete="off"
                        className="otpInput"
                        value={otp3}
                        onChange={(e) => handleChangeOtp3(e)}
                        tabIndex="3"
                        maxLength="1"
                        onFocus={handleInput}
                        onKeyUp={(e) => handleOTPfocus(e)}
                      />
                      <input
                        name="otp4"
                        type="text"
                        id="otp4"
                        data-prev="otp3"
                        autoComplete="off"
                        className="otpInput"
                        value={otp4}
                        onChange={(e) => handleChangeOtp4(e)}
                        tabIndex="4"
                        maxLength="1"
                        onFocus={handleInput}
                        onKeyUp={(e) => handleOTPfocus(e)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {otpErrorMsg ? (
              <span className={styles.errorMsgContact}>Enter valid OTP</span>
            ) : (
              ""
            )}
            {errorMsg ? (
              <span className={styles.errorMsgContactOtp}>Required</span>
            ) : (
              ""
            )}
            {!otpVerified ? (
              <span className={styles.errorMsgContact}>
                Verify contact number
              </span>
            ) : (
              ""
            )}

            <div
              className={`formSubmit ${styles.contactSubmit}`}
              onClick={handleSubmit}
            >
              SUBMIT
            </div>
          </FormControl>
        </div>
      </div>
      <div className={styles.disclaimerContainer}>
        <div className={styles.disclaimerCard}>
          <div className={styles.disclaimerContent}>
            <p className={styles.note}>
              {disclaimer.length > 0
                ? ReactHtmlParser(disclaimer[0].description)
                : ""}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default OpenAnAccount;
